import React from "react";

const NewReportActions = ({ isPaid }) => {
  if (!isPaid) return null; // Render nothing if isPaid is false

  return (
    <div className="container mt-5 p-4 border rounded shadow-sm" style={{ maxWidth: "900px" }}>
      <p className="text-center mb-4 fw-bold text-secondary">
        If you wish to create a new report, click the <strong>"Create New Calculation"</strong>.
      </p>
      <div className="text-center">
        <button
          className="btn btn-success btn-lg"
          onClick={() => (window.location.href = "/calculator")} // Redirect to the homepage or reset the form
        >
          <i className="bi bi-plus-circle"></i> Create New Calculation
        </button>
      </div>
    </div>
  );
};

export default NewReportActions;